import { officialEmotes } from './official-emotes';
import { DA_COMM_EMOTE } from './types';
import escapeRegExp from 'lodash/escapeRegExp';
// Extract the codes
const officialEmotesCodes = Object.keys(officialEmotes);
// This wraps the codes to match boundaries
const regexWrapper = (emotes)=>`(${emotes})( )`;
// This creates a single huge! regex for all emotes
const officialEmotesRegex = new RegExp(regexWrapper(officialEmotesCodes.map(escapeRegExp).join('|')), 'g');
const findWithRegex = (regex, contentBlock, callback)=>{
    // Get the text from the contentBlock
    const text = contentBlock.getText();
    let matchArr;
    let start;
    // tslint:disable-next-line
    while((matchArr = regex.exec(text)) !== null){
        start = matchArr.index;
        callback(start, start + matchArr[0].length);
    }
};
export default function(contentBlock, callback, contentState) {
    // Official emotes
    findWithRegex(officialEmotesRegex, contentBlock, callback);
    if (!contentState) {
        return;
    }
    // Community emotes
    contentBlock.findEntityRanges((character)=>{
        const entityKey = character.getEntity();
        return entityKey !== null && contentState.getEntity(entityKey).getType() === DA_COMM_EMOTE;
    }, callback);
}
